import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Upload, Loader } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function KYCVerification() {
  const navigate = useNavigate();
  const [showProgress, setShowProgress] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    bankAccount: '',
    idFile: null as File | null
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowProgress(true);
  };
  return <div className="min-h-screen" data-id="element-188">
      <div className="max-w-md mx-auto" data-id="element-189">
        {/* Header */}
        <div className="flex items-center gap-4 p-5 pt-8" data-id="element-190">
          <button onClick={() => navigate('/profile')} className="w-10 h-10 rounded-full glass-card flex items-center justify-center text-white hover:bg-white/[0.08] transition-colors" data-id="element-191">
            <ArrowLeft className="w-5 h-5" data-id="element-192" />
          </button>
          <h1 className="text-white text-2xl font-bold tracking-tight" data-id="element-193">
            KYC Verification
          </h1>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="px-5 space-y-5 pb-10" data-id="element-194">
          <div className="glass-card p-5 space-y-5" data-id="element-195">
            <div data-id="element-196">
              <label className="text-label mb-2 block" data-id="element-197">Full Name</label>
              <input type="text" value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} placeholder="As it appears on your ID" required className="w-full glass-input px-4 py-3.5 placeholder-[#475569]" data-id="element-198" />
            </div>

            <div data-id="element-199">
              <label className="text-label mb-2 block" data-id="element-200">Phone Number</label>
              <div className="flex gap-2" data-id="element-201">
                <input type="tel" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} placeholder="+234 800 000 0000" required className="flex-1 glass-input px-4 py-3.5 placeholder-[#475569] font-mono" data-id="element-202" />
                <button type="button" className="bg-white/[0.08] hover:bg-white/[0.12] text-white border border-white/[0.1] rounded-xl px-4 py-3.5 font-bold tracking-tight whitespace-nowrap transition-colors" data-id="element-203">
                  Send OTP
                </button>
              </div>
            </div>

            <div data-id="element-204">
              <label className="text-label mb-2 block" data-id="element-205">Email</label>
              <input type="email" value={formData.email} onChange={e => setFormData({
              ...formData,
              email: e.target.value
            })} placeholder="your@email.com" required className="w-full glass-input px-4 py-3.5 placeholder-[#475569]" data-id="element-206" />
            </div>

            <div data-id="element-207">
              <label className="text-label mb-2 block" data-id="element-208">
                Bank Account (BVN Match)
              </label>
              <input type="text" value={formData.bankAccount} onChange={e => setFormData({
              ...formData,
              bankAccount: e.target.value
            })} placeholder="0123456789" required maxLength={10} className="w-full glass-input px-4 py-3.5 placeholder-[#475569] font-mono tracking-widest" data-id="element-209" />
            </div>

            <div data-id="element-210">
              <label className="text-label mb-2 block" data-id="element-211">
                Upload ID Document
              </label>
              <div className="bg-white/[0.02] rounded-xl p-6 border-2 border-dashed border-white/[0.1] hover:border-[#00D68F]/50 transition-colors cursor-pointer group" data-id="element-212">
                <input type="file" accept="image/*,.pdf" onChange={e => setFormData({
                ...formData,
                idFile: e.target.files?.[0] || null
              })} className="hidden" id="id-upload" data-id="element-213" />
                <label htmlFor="id-upload" className="flex flex-col items-center cursor-pointer" data-id="element-214">
                  <div className="w-12 h-12 rounded-full bg-white/[0.04] flex items-center justify-center mb-3 group-hover:bg-[#00D68F]/10 transition-colors" data-id="element-215">
                    <Upload className="w-6 h-6 text-[#64748B] group-hover:text-[#00D68F] transition-colors" data-id="element-216" />
                  </div>
                  <p className="text-white font-bold tracking-tight mb-1" data-id="element-217">
                    {formData.idFile ? formData.idFile.name : 'Tap to upload ID'}
                  </p>
                  <p className="text-[#64748B] text-xs font-medium" data-id="element-218">
                    NIN, Driver's License, or Passport
                  </p>
                </label>
              </div>
            </div>
          </div>

          <motion.button whileTap={{
          scale: 0.97
        }} type="submit" className="w-full bg-[#00D68F] text-[#0A0E1A] rounded-2xl py-4 font-bold text-lg shadow-[0_0_20px_rgba(0,214,143,0.2)] mt-2" data-id="element-219">
            Submit Verification
          </motion.button>
        </form>
      </div>

      {/* Progress Modal */}
      <AnimatePresence data-id="element-220">
        {showProgress && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-[#0A0E1A]/90 backdrop-blur-xl flex items-center justify-center z-50 px-5" data-id="element-221">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} className="glass-card border-white/[0.1] p-8 text-center max-w-sm w-full shadow-2xl" data-id="element-222">
              <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'linear'
          }} className="w-16 h-16 mx-auto mb-6 flex items-center justify-center" data-id="element-223">
                <Loader className="w-10 h-10 text-[#00D68F]" data-id="element-224" />
              </motion.div>
              <h3 className="text-white text-2xl font-bold tracking-tight mb-2" data-id="element-225">
                Processing
              </h3>
              <p className="text-[#64748B]" data-id="element-226">
                Securely verifying your documents. This usually takes 24 hours.
              </p>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}